module.exports = __webpack_public_path__ + "static/media/3.d028c6fb.JPG";